import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "header modulewrap"
};
const _hoisted_2 = {
  class: "nav"
};
const _hoisted_3 = {
  class: "logo"
};
const _hoisted_4 = {
  class: "navmain"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "navline"
}, null, -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "navline"
}, null, -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dl", {
  class: "navlogin"
}, [/*#__PURE__*/_createElementVNode("dd", null, "登录/注册"), /*#__PURE__*/_createElementVNode("dd", null, [/*#__PURE__*/_createElementVNode("span", {
  class: "cs"
}, "中文"), /*#__PURE__*/_createTextVNode(" | EN")])], -1);
const _hoisted_8 = {
  class: "banner"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 0,
  class: "bannerinfowrap"
};
const _hoisted_11 = {
  class: "bannerinfo"
};
const _hoisted_12 = {
  class: "bannertitle"
};
const _hoisted_13 = ["innerHTML"];
export default {
  __name: 'Cheader',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const FFdata = reactive({
      isHome: true,
      listNav: [],
      listBanner: [],
      isScroll: false //是否滚动，调整顶部导航
    });

    const CisHome = computed(() => !proxy.$store.navAlias);
    const ChomeBanner = computed(() => {
      let banner = '';
      proxy.$common.each(FFdata.listBanner, item => {
        banner += ',' + item.imgs;
      });
      return banner ? banner.substring(1) : '';
    });
    const Cnav = computed(() => {
      let nav = {};
      proxy.$common.each(FFdata.listNav, item => {
        if (item.alias == proxy.$store.navAlias) {
          nav = item;
        }
      });
      return nav;
    });
    const Cbanner = computed(() => {
      return Cnav.value.imgs || '';
    });
    const getData = () => {
      proxy.$common.fetch({
        'act': 'gen_navinfo',
        msg: ''
      }, res => {
        FFdata.listNav = res.infodata;
        FFdata.listBanner = res.infodatabanner;
      });
    };
    const headerScroll = () => {
      let scrolltop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      FFdata.isScroll = scrolltop > 100;
    };
    onMounted(() => {
      getData();
      window.addEventListener('scroll', headerScroll, false);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', headerScroll, false);
    });
    return (_ctx, _cache) => {
      const _component_ffimg = _resolveComponent("ffimg");
      const _component_router_link = _resolveComponent("router-link");
      const _component_ffswiper = _resolveComponent("ffswiper");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(['navwrap', _unref(CisHome) ? 'fixed2' : '', _unref(FFdata).isScroll ? 'topfixed' : ''])
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_ffimg, {
          alias: "sei_logohome"
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_4, [_createElementVNode("dl", null, [_createElementVNode("dd", {
        class: _normalizeClass({
          cs: _unref(CisHome)
        })
      }, [_createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_createTextVNode("首页")]),
        _: 1
      }), _hoisted_5], 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FFdata).listNav, item => {
        return _openBlock(), _createElementBlock("dd", {
          key: item.id,
          class: _normalizeClass({
            cs: item.alias == _ctx.$store.navAlias
          })
        }, [_createVNode(_component_router_link, {
          to: item.url
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
          _: 2
        }, 1032, ["to"]), _hoisted_6], 2);
      }), 128))])]), _hoisted_7])], 2), _createElementVNode("div", _hoisted_8, [_unref(CisHome) ? (_openBlock(), _createBlock(_component_ffswiper, {
        key: 0,
        imgs: _unref(ChomeBanner)
      }, null, 8, ["imgs"])) : _unref(Cbanner) ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createElementVNode("img", {
        src: _unref(Cbanner)
      }, null, 8, _hoisted_9), _unref(Cnav).title ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(_unref(Cnav).title), 1), _createElementVNode("div", {
        class: "bannersubtitle",
        innerHTML: _unref(Cnav).content
      }, null, 8, _hoisted_13)])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)])]);
    };
  }
};